(function (window, document) {
  'use strict';
  if (window.__gbfs) return;
  window.__gbfs = 2;

  var TRANSFORM_STYLE_ID = 'gbfs-transform-styles';
  var TRANSFORM_STYLE_TEXT = [
    "  /* Smooth the free-shipping bar with a transform while the source's inline width stays inert. */",
    '  .cart-drawer .gbfs .gbfs-fill[data-gbfs-fill] {',
    '    width: 100% !important;',
    '    transform: scaleX(0);',
    '    transform-origin: left center;',
    '    transition: transform 0.3s ease;',
    '    will-change: transform;',
    '  }',
    '  @media (prefers-reduced-motion: reduce) {',
    '    .cart-drawer .gbfs .gbfs-fill[data-gbfs-fill] {',
    '      transition: none;',
    '      will-change: auto;',
    '    }',
    '  }'
  ].join('\n');

  function installTransformStyles() {
    if (!document.head || document.getElementById(TRANSFORM_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = TRANSFORM_STYLE_ID;
    style.textContent = TRANSFORM_STYLE_TEXT;
    document.head.appendChild(style);
  }

  installTransformStyles();

  var booted = false;
  var latestCart = null;
  var labels = [];
  var drawer = null;
  var framePending = false;
  var pendingFrameId = null;
  var replacementPending = false;
  var lastProgress = null;
  var formatters = Object.create(null);

  function reducedMotion() {
    try { return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
    catch (error) { return false; }
  }

  function setStyleIfChanged(node, property, value) {
    if (node && node.style && node.style[property] !== value) node.style[property] = value;
  }

  function setAttributeIfChanged(node, name, value) {
    if (!node || !node.getAttribute || !node.setAttribute) return;
    var text = String(value);
    if (node.getAttribute(name) !== text) node.setAttribute(name, text);
  }

  function currentLabels(scope) {
    return scope ? Array.from(scope.querySelectorAll('[data-gbfs-amt], [data-gbfs-fill]')) : [];
  }

  function sameNodes(left, right) {
    return left.length === right.length && left.every(function (node, index) { return node === right[index]; });
  }

  function hasBarMarker(node) {
    if (!node || node.nodeType !== 1) return false;
    try {
      if (node.matches && node.matches('[data-gbfs], [data-gbfs-amt], [data-gbfs-fill]')) return true;
      return Boolean(node.querySelector && node.querySelector('[data-gbfs], [data-gbfs-amt], [data-gbfs-fill]'));
    } catch (error) { return false; }
  }

  function recordAddsOrRemovesBar(record) {
    var nodes = [];
    if (record && record.addedNodes) nodes = nodes.concat(Array.from(record.addedNodes));
    if (record && record.removedNodes) nodes = nodes.concat(Array.from(record.removedNodes));
    return nodes.some(hasBarMarker);
  }

  function fillNode(node) {
    try { return Boolean(node && node.matches && node.matches('[data-gbfs-fill]')); }
    catch (error) { return false; }
  }

  function transformFor(progress, done) {
    var value = Math.max(0, Math.min(1, Number(progress) || 0));
    if (!done && value >= 1) value = 1 - 2.220446049250313e-16;
    return 'scaleX(' + String(value) + ')';
  }

  function requestFrame(callback) {
    if (window.requestAnimationFrame) return window.requestAnimationFrame(callback);
    return window.setTimeout(callback, 16);
  }

  function formatter(currency, localeKey) {
    var key = String(currency) + '\u0000' + String(localeKey || '');
    if (Object.prototype.hasOwnProperty.call(formatters, key)) return formatters[key];
    try { formatters[key] = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }); }
    catch (error) { formatters[key] = null; }
    return formatters[key];
  }

  function money(cents, currency, localeKey) {
    var value = Math.max(0, Number(cents) || 0) / 100;
    var instance = formatter(currency, localeKey);
    return instance ? instance.format(value) : value.toFixed(2) + ' ' + currency;
  }

  function currentLocaleKey() {
    var locale = window.navigator && (window.navigator.language || window.navigator.userLanguage);
    return locale ? String(locale).replace(/_/g, '-') : '';
  }

  function safeGoal(currency) {
    var rate = Number(currency.rate);
    if (!Number.isFinite(rate) || rate <= 0) rate = 1;
    var maxRate = (Number.MAX_SAFE_INTEGER || 9007199254740991) / 7000;
    rate = Math.min(rate, maxRate);
    var goal = Math.round(7000 * rate);
    return Number.isFinite(goal) && goal > 0 ? goal : 7000;
  }

  function paint(cart, preserveFillProgress) {
    if (!cart) return;
    latestCart = cart;
    var currency = window.Shopify && window.Shopify.currency || {};
    var activeCurrency = currency.active || 'USD';
    var goal = safeGoal(currency);
    var rawTotal = Number(cart.total_price);
    var total = Number.isFinite(rawTotal) ? Math.max(0, rawTotal) : 0;
    var items = Array.isArray(cart.items) ? cart.items : [];
    var eduFree = items.some(function (item) {
      return item && item.handle === 'raven-firearm-education-edition' && Number(item.quantity || 0) >= 2;
    });
    var done = total >= goal || eduFree;
    var progress = done ? 1 : Math.max(0, Math.min(1, total / goal));
    var transform = transformFor(progress, done);
    var amount = money(Math.max(0, goal - total), activeCurrency, currentLocaleKey());
    var reduce = reducedMotion();
    var roots = document.querySelectorAll('[data-gbfs]');

    Array.from(roots).forEach(function (root) {
      var fill = root.querySelector('[data-gbfs-fill]');
      var label = root.querySelector('[data-gbfs-amt]');
      var track = root.querySelector('.gbfs-track');
      if (fill) {
        if (!preserveFillProgress) {
          setStyleIfChanged(fill, 'transition', reduce ? 'none' : '');
          setStyleIfChanged(fill, 'transform', transform);
        }
      }
      if (root.classList.contains('gbfs-done') !== done) root.classList.toggle('gbfs-done', done);
      if (!done && label && label.textContent !== amount) label.textContent = amount;
      if (track) {
        setAttributeIfChanged(track, 'role', 'progressbar');
        setAttributeIfChanged(track, 'aria-label', 'Free shipping progress');
        setAttributeIfChanged(track, 'aria-valuemin', '0');
        setAttributeIfChanged(track, 'aria-valuemax', '100');
        setAttributeIfChanged(track, 'aria-valuenow', String(done ? 100 : Math.max(0, Math.min(99, Math.floor(progress * 100)))));
      }
    });

    if (!preserveFillProgress) lastProgress = progress;
    labels = currentLabels(drawer);
  }

  function schedulePaint(cart) {
    if (cart) latestCart = cart;
    if (!latestCart || framePending || replacementPending) return;
    framePending = true;
    pendingFrameId = requestFrame(function () {
      framePending = false;
      pendingFrameId = null;
      paint(latestCart);
    });
  }

  function cancelPendingPaint() {
    if (!framePending) return;
    if (window.cancelAnimationFrame && pendingFrameId != null) window.cancelAnimationFrame(pendingFrameId);
    else if (window.clearTimeout && pendingFrameId != null) window.clearTimeout(pendingFrameId);
    framePending = false;
    pendingFrameId = null;
  }

  function seedNewFills(current) {
    if (lastProgress == null) return false;
    var seeded = false;
    current.forEach(function (node) {
      if (!fillNode(node) || labels.indexOf(node) >= 0) return;
      setStyleIfChanged(node, 'transition', 'none');
      setStyleIfChanged(node, 'transform', transformFor(lastProgress, lastProgress === 1));
      seeded = true;
    });
    return seeded;
  }

  function animateAfterReplacement() {
    if (replacementPending) return;
    replacementPending = true;
    requestFrame(function () {
      requestFrame(function () {
        replacementPending = false;
        paint(latestCart);
      });
    });
  }

  function observeDrawer() {
    drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    labels = currentLabels(drawer);
    new MutationObserver(function (records) {
      if (!records || !records.some(recordAddsOrRemovesBar)) return;
      var current = currentLabels(drawer);
      if (sameNodes(current, labels)) return;
      var seeded = seedNewFills(current);
      labels = current;
      if (!latestCart) return;
      if (seeded) {
        cancelPendingPaint();
        paint(latestCart, true);
        animateAfterReplacement();
      }
      else schedulePaint(latestCart);
    }).observe(drawer, { childList: true, subtree: true });
  }

  function boot() {
    if (booted || !window.GBCart || !window.GBCart.readCart) return;
    booted = true;
    window.GBCart.subscribe(schedulePaint);
    window.GBCart.readCart().then(schedulePaint).catch(function () {});
    observeDrawer();
  }

  document.addEventListener('gb:cart-ready', boot, { once: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})(window, document);
